import { useQuery } from '@tanstack/react-query';
import { Warehouse } from '@models/warehouse.model';
import { warehouseService } from '@services/warehouse';

export const WAREHOUSE_QUERY_KEY = ['warehouse'];

export const useWarehouse = (warehouseId: string | undefined) => {
  return useQuery<Warehouse, Error>({
    queryKey: [...WAREHOUSE_QUERY_KEY, warehouseId],
    queryFn: async () => {
      if (!warehouseId) throw new Error('warehouseId is required');
      return await warehouseService.getWarehouse(warehouseId);
    },
    enabled: !!warehouseId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export default useWarehouse;
